import React, { useEffect, useState, useRef } from "react";
import { createRfid, deleteRfid, exportRfid, fetchAllRfid, importRfid, updateRfid } from "../../../resources/RfidResource";
import DataTable from 'react-data-table-component';
import { showSuccessToast } from "../../../utils/GlobalToast";
import { format } from "date-fns";
import { getLocalAuth } from "../../../utils/AuthUtils";
import ErrorNotFound from "../../errors/Error";
import FormatDownload from "../../../components/format-download";

function Rfid() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter(data => {
    return data.code === "RFID"
  });

  let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Read"
  });

  let dataCreate = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Create"
  });

  let dataUpdate = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Update"
  });

  let dataDelete = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Delete"
  });

  let dataImport = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Import"
  });

  let dataExport = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Export"
  });

  const [dataRfid, setDataRfid] = useState([]);
  const [name, setName] = useState("");
  const [noRfid, setNoRfid] = useState("");
  const [idEdit, setIdEdit] = useState(null);
  const [nameEdit, setNameEdit] = useState("");
  const [noRfidEdit, setNoRfidEdit] = useState("");

  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState("");
  const [isErrorEdit, setIsErrorEdit] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [isErrorImport, setIsErrorImport] = useState(false);
  const [errorImport, setErrorImport] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const inputRef = useRef(null);
  const inputRef2 = useRef(null);

  const onChangeRfid = (e) => {
    setNoRfid(e.target.value);

    if (e.target.value.length > 15) {
      setTimeout(() => {
        if (inputRef2.current) {
          inputRef2.current.focus();
        }
      }, 200);
    }
  }

  const fetchRfid = () => {
    fetchAllRfid()
      .then((res) => {

        setDataRfid(res.data);
      })
      .catch((err) => {
        setDataRfid([]);
      });
  };

  useEffect(() => {
    fetchRfid();

  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    postRfid(noRfid, name);
  }

  const handleImport = (e) => {
    e.preventDefault();

    postImportRfid(selectedFile);
  }

  const getExportRfid = () => {
    exportRfid().then((res) => {
    })
      .catch((err) => {
        console.log(err);
      });
  }

  const postImportRfid = (selectedFile) => {
    setIsLoading(true);
    importRfid(selectedFile).then((res) => {
      setIsLoading(false);
      setIsErrorImport(false);
      showSuccessToast("Success Import RFID!");
      setShowImportModal(false);
      fetchRfid();
    }).catch((err) => {
      setIsLoading(false);
      setErrorImport(err);
      setIsErrorImport(true);
    });
  }

  const postRfid = (noRfid, name) => {
    setIsLoading(true);
    createRfid(noRfid, name).then((res) => {
      setIsLoading(false);
      setIsError(false);
      showSuccessToast("Success Added RFID!");
      setShowAddModal(false);
      setName("");
      setNoRfid("");
      fetchRfid();
    }).catch((err) => {
      setIsLoading(false);
      setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
      setIsError(true);
    });
  }

  const handleData = (data) => {
    setIdEdit(data.id);
    setNameEdit(data.name);
    setNoRfidEdit(data.rfid_number);
  }

  const handleDelete = () => {
    setIsLoading(true);
    deleteRfid(idEdit).then((res) => {
      setIsLoading(false);
      setIsErrorDelete(false);
      showSuccessToast("Success Deleted RFID!");
      setShowDeleteModal(false);
      fetchRfid();
    }).catch((err) => {
      setIsLoading(false);
      setErrorDelete(err);
      setIsErrorDelete(true);
    });
  }

  const handleEdit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    updateRfid(idEdit, nameEdit).then((res) => {
      setIsLoading(false);
      setIsErrorEdit(false);
      showSuccessToast("Success Updated RFID!");
      setShowEditModal(false);
      fetchRfid();
    }).catch((err) => {
      setIsLoading(false);
      setErrorEdit(err);
      setIsErrorEdit(true);
    });
  }

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'RFID',
      selector: row => row.rfid_number,
      sortable: true,
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => row.created_at === null ? '-' : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: 'Updated At',
      selector: row => row.updated_at === null ? '-' : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          {dataDelete.length === 0 ? <div></div> : !dataDelete[0].is_active ? <div></div> : <button type="button" style={{ marginRight: "8px" }} className="btn btn-danger" onClick={() => {
            handleData(row);
            setShowDeleteModal(true);
          }}>Delete</button>}
          <div className={`modal fade ${showDeleteModal ? 'show' : ''}`} style={{ display: showDeleteModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete this data?</h5>
                  <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)} aria-label="Close"></button>
                </div>
                {isErrorDelete ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorDelete}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorDelete(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  {`You will delete ${noRfidEdit}`}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                  {!isLoading ? <button type="submit" className="btn btn-danger" onClick={() => handleDelete()}>Delete</button> :
                    <button className="btn btn-danger" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Loading...</button>}
                </div>
              </div>
            </div>
          </div>
          {dataUpdate.length === 0 ? <div></div> : !dataUpdate[0].is_active ? <div></div> : <button type="button" className="btn btn-info" onClick={() => {
            handleData(row);
            setShowEditModal(true);
          }}>View</button>}
          <div className={`modal fade ${showEditModal ? 'show' : ''}`} style={{ display: showEditModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Master Data RFID</h5>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)} aria-label="Close"></button>
                </div>
                {isErrorEdit ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorEdit}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorEdit(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  <form onSubmit={handleEdit}>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Name</label>
                      <input required type="text" value={nameEdit} onChange={(e) => setNameEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                      {!isLoading ? <button type="submit" className="btn btn-info">Save</button> :
                        <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...</button>}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row">
                    <div className="col">
                      <h4 className="mb-0">Master Data RFID</h4>
                    </div>
                    <div className="col">
                      <div className="text-end">
                        {dataCreate.length === 0 ? <div></div> : !dataCreate[0].is_active ? <div></div> : <button type="button" className="btn btn-info ms-auto radius-10" onClick={() => {
                          setShowAddModal(true);
                          setTimeout(() => {
                            if (inputRef.current) {
                              inputRef.current.focus();
                            }
                          }, 200);
                        }} style={{ marginRight: '8px' }}><i className='bx bx-plus'></i> RFID</button>}
                        {dataImport.length === 0 ? <div></div> : !dataImport[0].is_active ? <div></div> : <button type="button" className="btn btn-success ms-auto radius-10" onClick={() => {
                          setShowImportModal(true);
                        }} style={{ marginRight: '8px' }}><i className='bx bx-import'></i> Import</button>}
                        {dataExport.length === 0 ? <div></div> : !dataExport[0].is_active ? <div></div> : <button type="button" className="btn btn-primary ms-auto radius-10" onClick={() => {
                          getExportRfid();
                        }}><i className='bx bx-export'></i> Export</button>}
                      </div>
                    </div>
                    <div className={`modal fade ${showImportModal ? 'show' : ''}`} style={{ display: showImportModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Import Data RFID</h5>
                            <button type="button" className="btn-close" onClick={() => {
                              setShowImportModal(false);
                            }} aria-label="Close"></button>
                          </div>
                          {isErrorImport ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorImport}
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorImport(false)}></button>
                            </div>
                          </div> : null}
                          <div className="modal-body">
                            <FormatDownload url={'/List RFID.xlsx'} />
                            <form onSubmit={handleImport}>
                              <div className="mb-3">
                                <input required className="form-control" type="file" id="formFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) =>
                                  setSelectedFile(e.target.files[0])
                                } />
                              </div>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => {
                                  setShowImportModal(false);
                                }}>Cancel</button>
                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                  <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...</button>}
                              </div>
                            </form></div>
                        </div>
                      </div>
                    </div>
                    <div className={`modal fade ${showAddModal ? 'show' : ''}`} style={{ display: showAddModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Master Data RFID</h5>
                            <button type="button" className="btn-close" onClick={() => {
                              setShowAddModal(false);
                            }} aria-label="Close"></button>
                          </div>
                          {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                            </div>
                          </div> : null}
                          <div className="modal-body">
                            <form onKeyDown={(e) => handleKeyDown(e)} onSubmit={(e) => handleSubmit(e)}>
                              <div className="mb-3">
                                <label className="form-label fw-bold">RFID</label>
                                <input required autoFocus ref={inputRef} type="text" className="form-control" value={noRfid} onChange={onChangeRfid} placeholder="Scan Here" />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Name</label>
                                <input required ref={inputRef2} type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                              </div>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => {
                                  setShowAddModal(false);
                                }}>Cancel</button>
                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                  <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...</button>}
                              </div>
                            </form></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={dataRfid}
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default Rfid